export const RECON_BADGE = {
  conciliado: { label: "Conciliado", cls: "text-green-700 border-green-200 bg-green-50" },
  categorizado: { label: "Categorizado", cls: "text-blue-700 border-blue-200 bg-blue-50" },
  ignorado: { label: "Ignorado", cls: "text-slate-500 border-slate-200 bg-slate-50" },
  pendiente: { label: "Pendiente", cls: "text-amber-700 border-amber-200 bg-amber-50" },
};
